import React from 'react';

const DoodleBackground = () => {
  const p = '#7851A9';

  return (
    <div className="doodle-bg">
      <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id="doodleTile" x="0" y="0" width="500" height="480" patternUnits="userSpaceOnUse">

            {/* === Organic dashed paths weaving between icons === */}
            <path d="M 12 58 C 65 22, 130 95, 195 62" stroke={p} strokeWidth="1" fill="none" strokeDasharray="5,5" opacity="0.16"/>
            <path d="M 195 62 C 240 38, 310 110, 370 72" stroke={p} strokeWidth="1" fill="none" strokeDasharray="5,5" opacity="0.14"/>
            <path d="M 370 72 C 420 50, 460 130, 490 105" stroke={p} strokeWidth="0.8" fill="none" strokeDasharray="4,5" opacity="0.13"/>
            <path d="M 55 185 C 100 155, 170 230, 235 190" stroke={p} strokeWidth="1" fill="none" strokeDasharray="5,5" opacity="0.15"/>
            <path d="M 310 210 C 360 180, 420 260, 480 220" stroke={p} strokeWidth="0.8" fill="none" strokeDasharray="5,5" opacity="0.13"/>
            <path d="M 80 330 C 140 290, 200 370, 270 320" stroke={p} strokeWidth="1" fill="none" strokeDasharray="5,5" opacity="0.15"/>
            <path d="M 340 360 C 390 330, 440 400, 490 370" stroke={p} strokeWidth="0.8" fill="none" strokeDasharray="4,5" opacity="0.13"/>
            <path d="M 28 58 C 40 110, 60 140, 55 185" stroke={p} strokeWidth="0.8" fill="none" strokeDasharray="4,4" opacity="0.12"/>
            <path d="M 370 72 C 355 120, 330 170, 310 210" stroke={p} strokeWidth="0.8" fill="none" strokeDasharray="4,4" opacity="0.12"/>
            <path d="M 235 190 C 250 250, 265 290, 270 320" stroke={p} strokeWidth="0.8" fill="none" strokeDasharray="4,4" opacity="0.12"/>
            <path d="M 145 420 C 190 400, 250 440, 340 410" stroke={p} strokeWidth="0.8" fill="none" strokeDasharray="5,5" opacity="0.14"/>

            {/* === AIRPLANE — top-left === */}
            <g opacity="0.2" transform="translate(8, 32) rotate(-20, 15, 15) scale(0.14)">
              <path d="M126.367,114.545h3.332l99.646,38.573v-32.72l-22.96-11.871V84.551c0-2.99-2.433-5.413-5.442-5.413c-2.999,0-5.422,2.423-5.422,5.413v18.387l-29.271-15.114V62.959c0-2.98-2.443-5.383-5.432-5.383s-5.422,2.403-5.422,5.383v19.267l-25.715-13.268h-1.378l1.798-41.699c-0.02-10.063-8.158-18.221-18.231-18.221c-10.063,0-18.231,8.148-18.231,18.221l1.798,41.699h-2.198L74.243,79.431V62.959c0-2.98-2.433-5.383-5.432-5.383c-2.999,0-5.403,2.403-5.403,5.383V85.44L39.54,98.591V80.829c0-2.99-2.443-5.422-5.422-5.422c-2.999,0-5.422,2.433-5.422,5.422v23.742L0,120.398v32.73l93.227-38.573h4.143l2.697,62.998c0,3.615,0.244,6.986,1.006,9.839l-30.366,16.727l-3.879,16.189l38.895-6.722h13.668l41.289,6.722l-3.879-16.189L122.83,186.6c0.606-2.687,0.84-5.764,0.84-9.057L126.367,114.545z" fill="none" stroke={p} strokeWidth="8"/>
            </g>

            {/* === TRUCK — upper-right area === */}
            <g opacity="0.2" transform="translate(350, 55) rotate(5, 16, 11)">
              <rect x="0" y="4" width="20" height="12" rx="1" fill="none" stroke={p} strokeWidth="1.2"/>
              <path d="M 20 4 L 28 4 L 32 10 L 32 16 L 20 16" fill="none" stroke={p} strokeWidth="1.2"/>
              <circle cx="7" cy="18" r="2.5" fill="none" stroke={p} strokeWidth="1.1"/>
              <circle cx="27" cy="18" r="2.5" fill="none" stroke={p} strokeWidth="1.1"/>
            </g>

            {/* === PACKAGE BOX — mid-upper, offset right === */}
            <g opacity="0.2" transform="translate(195, 45) rotate(8, 10, 10)">
              <rect x="0" y="5" width="16" height="14" fill="none" stroke={p} strokeWidth="1.2"/>
              <line x1="0" y1="5" x2="5" y2="0" stroke={p} strokeWidth="1.2"/>
              <line x1="16" y1="5" x2="21" y2="0" stroke={p} strokeWidth="1.2"/>
              <line x1="5" y1="0" x2="21" y2="0" stroke={p} strokeWidth="1.2"/>
              <line x1="21" y1="0" x2="21" y2="14" stroke={p} strokeWidth="1.2"/>
              <line x1="16" y1="19" x2="21" y2="14" stroke={p} strokeWidth="1.2"/>
              <line x1="8" y1="5" x2="8" y2="19" stroke={p} strokeWidth="0.7" strokeDasharray="2,2"/>
            </g>

            {/* === WALKING PERSON — left, mid zone === */}
            <g opacity="0.18" transform="translate(42, 170)">
              <circle cx="8" cy="2" r="2.5" fill="none" stroke={p} strokeWidth="1.2"/>
              <line x1="8" y1="5" x2="8" y2="14" stroke={p} strokeWidth="1.2"/>
              <line x1="8" y1="8" x2="2" y2="12" stroke={p} strokeWidth="1.1"/>
              <line x1="8" y1="8" x2="14" y2="11" stroke={p} strokeWidth="1.1"/>
              <line x1="8" y1="14" x2="3" y2="20" stroke={p} strokeWidth="1.1"/>
              <line x1="8" y1="14" x2="13" y2="20" stroke={p} strokeWidth="1.1"/>
            </g>

            {/* === CAR — center-left, slightly below mid === */}
            <g opacity="0.18" transform="translate(220, 178) rotate(-5, 12, 10)">
              <path d="M 4 8 L 6 2 L 18 2 L 20 8" fill="none" stroke={p} strokeWidth="1.1"/>
              <rect x="2" y="8" width="20" height="8" rx="2" fill="none" stroke={p} strokeWidth="1.2"/>
              <circle cx="7" cy="18" r="2.5" fill="none" stroke={p} strokeWidth="1.1"/>
              <circle cx="17" cy="18" r="2.5" fill="none" stroke={p} strokeWidth="1.1"/>
            </g>

            {/* === TRAIN — right side, mid-low === */}
            <g opacity="0.18" transform="translate(390, 190)">
              <rect x="0" y="0" width="14" height="18" rx="3" fill="none" stroke={p} strokeWidth="1.2"/>
              <rect x="14" y="2" width="12" height="16" rx="1" fill="none" stroke={p} strokeWidth="1.1"/>
              <rect x="26" y="2" width="12" height="16" rx="1" fill="none" stroke={p} strokeWidth="1.1"/>
              <line x1="0" y1="12" x2="14" y2="12" stroke={p} strokeWidth="0.8"/>
              <rect x="3" y="3" width="8" height="6" rx="1" fill="none" stroke={p} strokeWidth="0.8"/>
              <circle cx="5" cy="21" r="2" fill="none" stroke={p} strokeWidth="1.1"/>
              <circle cx="20" cy="21" r="2" fill="none" stroke={p} strokeWidth="1.1"/>
              <circle cx="33" cy="21" r="2" fill="none" stroke={p} strokeWidth="1.1"/>
            </g>

            {/* === BICYCLE — lower-left area === */}
            <g opacity="0.18" transform="translate(70, 310) rotate(6, 15, 10)">
              <circle cx="6" cy="14" r="6" fill="none" stroke={p} strokeWidth="1.1"/>
              <circle cx="24" cy="14" r="6" fill="none" stroke={p} strokeWidth="1.1"/>
              <path d="M 6 14 L 12 4 L 18 4 L 21 8 L 24 14" fill="none" stroke={p} strokeWidth="1.1"/>
              <line x1="12" y1="4" x2="15" y2="14" stroke={p} strokeWidth="0.9"/>
              <line x1="10" y1="2" x2="16" y2="2" stroke={p} strokeWidth="0.9"/>
            </g>

            {/* === SHIP — center-right, low === */}
            <g opacity="0.17" transform="translate(270, 300) rotate(-3, 14, 10)">
              <path d="M 4 12 L 0 20 L 28 20 L 24 12 Z" fill="none" stroke={p} strokeWidth="1.2"/>
              <rect x="10" y="4" width="8" height="8" fill="none" stroke={p} strokeWidth="1.1"/>
              <line x1="14" y1="4" x2="14" y2="0" stroke={p} strokeWidth="1.1"/>
              <path d="M 14 0 L 22 5" fill="none" stroke={p} strokeWidth="0.9"/>
            </g>

            {/* === SCOOTER — far right, low-mid === */}
            <g opacity="0.17" transform="translate(440, 290) rotate(4, 15, 10)">
              <circle cx="6" cy="16" r="4.5" fill="none" stroke={p} strokeWidth="1.1"/>
              <circle cx="24" cy="16" r="4.5" fill="none" stroke={p} strokeWidth="1.1"/>
              <path d="M 6 16 L 12 6 L 18 4 L 24 16" fill="none" stroke={p} strokeWidth="1.2"/>
              <rect x="13" y="2" width="6" height="4" rx="1" fill="none" stroke={p} strokeWidth="0.9"/>
            </g>

            {/* === SMALL PACKAGE — bottom far-left === */}
            <g opacity="0.15" transform="translate(140, 400) rotate(-10, 8, 8)">
              <rect x="0" y="3" width="12" height="12" fill="none" stroke={p} strokeWidth="1"/>
              <line x1="6" y1="3" x2="6" y2="15" stroke={p} strokeWidth="0.7" strokeDasharray="2,1"/>
              <line x1="0" y1="9" x2="12" y2="9" stroke={p} strokeWidth="0.7" strokeDasharray="2,1"/>
            </g>

            {/* === AIRPLANE 2 — bottom-right === */}
            <g opacity="0.18" transform="translate(360, 380) rotate(30, 15, 15) scale(0.14)">
              <path d="M126.367,114.545h3.332l99.646,38.573v-32.72l-22.96-11.871V84.551c0-2.99-2.433-5.413-5.442-5.413c-2.999,0-5.422,2.423-5.422,5.413v18.387l-29.271-15.114V62.959c0-2.98-2.443-5.383-5.432-5.383s-5.422,2.403-5.422,5.383v19.267l-25.715-13.268h-1.378l1.798-41.699c-0.02-10.063-8.158-18.221-18.231-18.221c-10.063,0-18.231,8.148-18.231,18.221l1.798,41.699h-2.198L74.243,79.431V62.959c0-2.98-2.433-5.383-5.432-5.383c-2.999,0-5.403,2.403-5.403,5.383V85.44L39.54,98.591V80.829c0-2.99-2.443-5.422-5.422-5.422c-2.999,0-5.422,2.433-5.422,5.422v23.742L0,120.398v32.73l93.227-38.573h4.143l2.697,62.998c0,3.615,0.244,6.986,1.006,9.839l-30.366,16.727l-3.879,16.189l38.895-6.722h13.668l41.289,6.722l-3.879-16.189L122.83,186.6c0.606-2.687,0.84-5.764,0.84-9.057L126.367,114.545z" fill="none" stroke={p} strokeWidth="8"/>
            </g>

            {/* === Accent: Envelope — scattered === */}
            <g opacity="0.13" transform="translate(130, 115) rotate(5, 8, 6)">
              <rect x="0" y="2" width="16" height="11" rx="1" fill="none" stroke={p} strokeWidth="1"/>
              <path d="M 0 2 L 8 8 L 16 2" fill="none" stroke={p} strokeWidth="0.8"/>
            </g>

            {/* === Accent: Location pin === */}
            <g opacity="0.13" transform="translate(450, 135)">
              <path d="M 7 0 C 3.1 0 0 3.1 0 7 C 0 12 7 18 7 18 C 7 18 14 12 14 7 C 14 3.1 10.9 0 7 0 Z" fill="none" stroke={p} strokeWidth="1"/>
              <circle cx="7" cy="7" r="2.5" fill="none" stroke={p} strokeWidth="0.8"/>
            </g>

            {/* === Accent: Clock === */}
            <g opacity="0.13" transform="translate(310, 120)">
              <circle cx="7" cy="7" r="7" fill="none" stroke={p} strokeWidth="1"/>
              <line x1="7" y1="7" x2="7" y2="3" stroke={p} strokeWidth="0.9"/>
              <line x1="7" y1="7" x2="10" y2="9" stroke={p} strokeWidth="0.9"/>
            </g>

            {/* === Accent: Globe === */}
            <g opacity="0.13" transform="translate(15, 255)">
              <circle cx="8" cy="8" r="8" fill="none" stroke={p} strokeWidth="1"/>
              <ellipse cx="8" cy="8" rx="4" ry="8" fill="none" stroke={p} strokeWidth="0.7"/>
              <line x1="0" y1="8" x2="16" y2="8" stroke={p} strokeWidth="0.7"/>
            </g>

            {/* === Accent: Walking person 2 — bottom-center === */}
            <g opacity="0.14" transform="translate(330, 440)">
              <circle cx="8" cy="2" r="2.5" fill="none" stroke={p} strokeWidth="1.1"/>
              <line x1="8" y1="5" x2="8" y2="14" stroke={p} strokeWidth="1.1"/>
              <line x1="8" y1="8" x2="2" y2="12" stroke={p} strokeWidth="1"/>
              <line x1="8" y1="8" x2="14" y2="11" stroke={p} strokeWidth="1"/>
              <line x1="8" y1="14" x2="3" y2="20" stroke={p} strokeWidth="1"/>
              <line x1="8" y1="14" x2="13" y2="20" stroke={p} strokeWidth="1"/>
            </g>

            {/* === Small dots scattered randomly === */}
            <circle cx="95" cy="80" r="1.2" fill={p} opacity="0.08"/>
            <circle cx="285" cy="145" r="1" fill={p} opacity="0.07"/>
            <circle cx="175" cy="260" r="1.2" fill={p} opacity="0.08"/>
            <circle cx="410" cy="340" r="1" fill={p} opacity="0.07"/>
            <circle cx="55" cy="420" r="1.2" fill={p} opacity="0.08"/>
            <circle cx="480" cy="440" r="1" fill={p} opacity="0.07"/>

          </pattern>
        </defs>

        <rect width="100%" height="100%" fill="url(#doodleTile)" />
      </svg>
    </div>
  );
};

export default DoodleBackground;
